module.exports = __webpack_public_path__ + "img/Neiin.ddbecc5a.svg";